import { apiClient, apiFetch, bearer, unwrap } from './client';
import type { components } from './types';

export type CustomerFileOut = components['schemas']['CustomerFileOut'];
export type CustomerFileListOut = components['schemas']['CustomerFileListOut'];

/** Customer-upload category, derived from the generated schema so it
 *  stays in sync with the `SourceDocumentCategory` Literal on the API. */
export type CustomerFileCategory = NonNullable<CustomerFileOut['category']>;

export function listPortalFiles(
  engagementId: string,
  idToken: string,
  category?: CustomerFileCategory,
): Promise<CustomerFileListOut> {
  return apiClient
    .GET('/api/portal/engagements/{engagement_id}/files', {
      params: {
        path: { engagement_id: engagementId },
        query: category ? { category } : undefined,
      },
      headers: bearer(idToken),
    })
    .then(unwrap<CustomerFileListOut>);
}

/** Multipart upload — on the legacy `apiFetch` path (openapi-fetch
 *  doesn't compose with `FormData` ergonomically). Mirrors the
 *  practitioner-side `uploadEngagementFile`. The `category` tags which
 *  onboarding section the file belongs to; defaults to `invoice` for
 *  callers that predate categorized uploads. */
export async function uploadPortalFile(
  engagementId: string,
  file: File,
  idToken: string,
  category: CustomerFileCategory = 'invoice',
): Promise<CustomerFileOut> {
  const form = new FormData();
  form.append('file', file);
  form.append('category', category);
  return apiFetch<CustomerFileOut>(
    `/api/portal/engagements/${encodeURIComponent(engagementId)}/files`,
    {
      idToken,
      method: 'POST',
      body: form,
    },
  );
}

export async function deletePortalFile(
  engagementId: string,
  fileId: string,
  idToken: string,
): Promise<void> {
  await apiClient
    .DELETE('/api/portal/engagements/{engagement_id}/files/{file_id}', {
      params: { path: { engagement_id: engagementId, file_id: fileId } },
      headers: bearer(idToken),
    })
    .then(unwrap<void>);
}
